var _circle, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateStaff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 40C32.732 40 39 36.866 39 33C39 29.134 32.732 26 25 26C17.268 26 11 29.134 11 33C11 36.866 17.268 40 25 40Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39.5C32.4558 39.5 38.5 36.5899 38.5 33C38.5 29.4101 32.4558 26.5 25 26.5C17.5442 26.5 11.5 29.4101 11.5 33C11.5 36.5899 17.5442 39.5 25 39.5Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30C30.5228 30 35 25.5228 35 20C35 14.4772 30.5228 10 25 10C19.4772 10 15 14.4772 15 20C15 25.5228 19.4772 30 25 30Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 29.5C30.2467 29.5 34.5 25.2467 34.5 20C34.5 14.7533 30.2467 10.5 25 10.5C19.7533 10.5 15.5 14.7533 15.5 20C15.5 25.2467 19.7533 29.5 25 29.5Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7143 36.35H29.25V32.5833H34.7143H34.9643V32.3333V27.25H39.0357V32.3333V32.5833H39.2857H44.75V36.35H39.2857H39.0357V36.6V42.75H34.9643V36.6V36.35H34.7143Z",
    fill: "white",
    stroke: "#FFAD45",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateStaff);
export default __webpack_public_path__ + "static/media/create-staff.e2508154667e4a7f6953140e9f354659.svg";
export { ForwardRef as ReactComponent };